import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ROUTE_LAST_TRACKING_LOADING = 'GET_ROUTE_LAST_TRACKING_LOADING';
export const GET_ROUTE_LAST_TRACKING_SUCCESS = 'GET_ROUTE_LAST_TRACKING_SUCCESS';
export const GET_ROUTE_LAST_TRACKING_REJECT = 'GET_ROUTE_LAST_TRACKING_REJECT';

//* ACTIONS ------------------------------------------------
export const getByLastTrackingRouteLoading = () => ({ type: GET_ROUTE_LAST_TRACKING_LOADING });
export const getByLastTrackingRouteSuccess = (payload) => ({ type: GET_ROUTE_LAST_TRACKING_SUCCESS, payload });
export const getByLastTrackingRouteReject = (payload) => ({ type: GET_ROUTE_LAST_TRACKING_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getByLastTrackingRouteRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Route/web/GetByLastTracking/${id}`, options);
};